module.exports = __webpack_public_path__ + "img/output-3.da44510c.png";